import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    resumen: [],
    carritosAbandonados: {
        currentPage: 0,
        totalPages: 0,
        results: []
    },
    resultBorrarCarrito:false,
    data: {
        pedidos: undefined,
        pedidoDetail: {},
        estadosPedido: undefined,
        formasEntrega: undefined,
        motivosEliminacion: undefined,
        sugerencias:[]
    },
    filtroPedidos: undefined,
    ultimaActualizacion: undefined,
    calendarioPedidos: undefined,
})

export default function testReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SET_RESUMEN_PEDIDOS){
        return state.setIn(["resumen"], action.payload)
    }

    if(action.type === ReducerActions.SET_CARRITOS_ABANDONADOS){
        return state.setIn(["carritosAbandonados"], action.payload)
    }
    
    if(action.type === ReducerActions.SET_RESULT_DELETE_CARRITO){
        return state.setIn(["resultBorrarCarrito"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_PEDIDOS){
        return state.setIn(["data", "pedidos"], action.payload)
    }
    if(action.type === ReducerActions.SAVE_PEDIDO){
        return state.setIn(["data", "pedidoDetail"], action.pedido)
    }

    if(action.type === ReducerActions.SAVE_PREPARAR_ITEM_PEDIDO_RESULT){
        let pedido = state.getIn(["data", "pedidoDetail"]);
        pedido = {...pedido} //creamos un nuevo objeto para que redux sepa que mutamos el estado!
        let item_index = pedido.pedidoDetalles.findIndex(x=> x.idDetallePedido === action.id);
        pedido.pedidoDetalles[item_index].listo = !action.revertir;
        return state.setIn(["data", "pedidoDetail"], pedido)
    }
    if(action.type === ReducerActions.SAVE_MARCAR_NO_DISPONIBLE_ITEM_PEDIDO_RESULT){
        let myState = state.toJS();
        //let pedido = state.getIn(["data", "pedidoDetail"]);
        let pedido = {...myState.data.pedidoDetail};
       //pedido = {...pedido} //creamos un nuevo objeto para que redux sepa que mutamos el estado!
        let item_index = pedido.pedidoDetalles.findIndex(x=> x.idDetallePedido === action.id);
        pedido.pedidoDetalles[item_index].noDisponible = !action.revertir;
        return state.setIn(["data", "pedidoDetail"], pedido)
    }
    if(action.type === ReducerActions.SAVE_IMAGEN_ARTICULO){
        let pedido = state.getIn(["data", "pedidoDetail"]);
        pedido = {...pedido} //creamos un nuevo objeto para que redux sepa que mutamos el estado!
        let item_index = pedido.pedidoDetalles.findIndex(x=> x.idDetallePedido === action.id);
        pedido.pedidoDetalles[item_index].imagen = action.imagen;
        return state.setIn(["data", "pedidoDetail"], pedido)
    }

    if(action.type === ReducerActions.SAVE_CAMBIAR_ESTADO_RESULT){
        let pedido = state.getIn(["data", "pedidoDetail"]);
        pedido = {...pedido} //creamos un nuevo objeto para que redux sepa que mutamos el estado!
        pedido.estadoPedido = action.estado;
        return state.setIn(["data", "pedidoDetail"], pedido)
    }

    if(action.type === ReducerActions.SAVE_ESTADOS_PEDIDO){
        return state.setIn(["data", "estadosPedido"], action.payload)
    }
    
    if(action.type === ReducerActions.SET_FORMAS_ENTREGA){
        return state.setIn(["data", "formasEntrega"], action.payload)
    }

    if(action.type === ReducerActions.SET_MOTIVOS_ELIMINACION){
        return state.setIn(["data", "motivosEliminacion"], action.payload)
    }

    if(action.type === ReducerActions.SET_LISTADO_SUGERENCIAS){
        return state.setIn(["data", "sugerencias"], action.payload)
    }

    if(action.type === ReducerActions.SET_FILTER_PEDIDOS){
        return state.setIn(["filtroPedidos"], action.payload)
    }
    
    if(action.type === ReducerActions.SET_ULTIMA_ACTUALIZACION){
        return state.setIn(["ultimaActualizacion"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_CALENDARIO_PEDIDOS){
        return state.setIn(["calendarioPedidos"], action.payload)
    }

    if(action.type === ReducerActions.SET_DIRECCIONES_ENTREGA){
        let myState = state.toJS()
        
        let pedido = {...myState.data.pedidoDetail}
        
        if(pedido !== undefined && pedido.listaDomicilios && pedido.listaDomicilios.length > 0 && action.payload){
            pedido.listaDomicilios.push(action.payload)
        }
        else{
            let domicilios = []
            domicilios.push(action.payload)
            pedido.listaDomicilios = domicilios
        }

        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                pedidoDetail: pedido
            }
        })
    }

    return state
}